import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { Box, Stack, Tooltip, Typography } from '@mui/material';
import React from 'react';

interface LabelProps {
  children: React.ReactNode;
  tooltip?: React.ReactNode;
}

const Label: React.FC<LabelProps> = ({ children, tooltip }) => (
  <Stack direction="row" alignItems="center" gap={0.5}>
    <Typography variant="body2" sx={{ fontWeight: 500 }}>
      {children}
    </Typography>
    {tooltip && (
      <Tooltip title={tooltip} placement="top">
        <InfoOutlined color="action" sx={{ width: '20px', height: '20px' }} />
      </Tooltip>
    )}
  </Stack>
);

const Text: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Typography variant="body2">{children}</Typography>
);

interface InfoGridProps {
  children: React.ReactNode;
  equalColumns?: boolean;
}

const InfoGrid: React.FC<InfoGridProps> & { Label: typeof Label; Text: typeof Text } = ({
  children,
  equalColumns = false
}) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: equalColumns ? '1fr 1fr' : 'max-content minmax(0, 1fr)',
      columnGap: 2,
      rowGap: 0.5,
      alignItems: 'center'
    }}
  >
    {children}
  </Box>
);

InfoGrid.Label = Label;
InfoGrid.Text = Text;

export default InfoGrid;
